export default __webpack_public_path__ + "static/media/blog-finder.640e1d95.png";